import React from 'react';
import { css } from '@compiled/react';
import { token } from '@atlaskit/tokens';

type CertificationCardSidePannelProps = {
  name: string | null;
  imageUrl: string | null;
};

const certificationCardStyles = css({
  display: 'flex',
  alignItems: 'center',
  maxWidth: '100%',
});

const certificationImageStyles = css({
  width: '37px',
  height: '37px',
  borderRadius: '50%',
  overflow: 'hidden',
});

const imgStyles = css({
  width: '100%',
  height: '100%',
});

const certificationNameStyles = css({
  fontFamily: token('font.family.brand.heading'),
  fontWeight: 600,
  fontSize: '16px',
  marginLeft: '12px',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  flex: '1',
});

const CertificationCardSidePannel: React.FC<
  CertificationCardSidePannelProps
> = ({ name, imageUrl }) => {
  return (
    <div css={certificationCardStyles}>
      <div css={certificationImageStyles}>
        <img src={imageUrl ?? ''} alt={`${name}'s profile`} css={imgStyles} />
      </div>
      <div css={certificationNameStyles}>{name}</div>
    </div>
  );
};

export default CertificationCardSidePannel;
